import api from 'api';

import type { NextRequest } from 'next/server';

interface Params {
  asPath: string;
  includeAdministeredGroups?: boolean;
  includeSupervisedGroups?: boolean;
  req: NextRequest & { headers: { cookie: string } };
}

const getGroupPageData = async ({
  asPath,
  includeAdministeredGroups,
  includeSupervisedGroups,
  req
}: Params) => {
  try {
    const groupId = parseInt(asPath.split('/')[2], 10);
    const headers = req ? { Cookie: req.headers.cookie } : {};
    const groups = await api.get(
      `/admin/groups?id=${groupId}` +
        (includeAdministeredGroups ? '&includeAdministeredGroups=true' : '') +
        (includeSupervisedGroups ? '&includeSupervisedGroups=true' : ''),
      { headers }
    );
    if (!groups.data.groups || !groups.data.groups.length) {
      const error = new Error() as Error & { response: { status: number } };
      error.response = { status: 404 };
      throw error;
    }
    return groups.data.groups[0];
  } catch (error) {
    return null;
  }
};

export default getGroupPageData;
